<script setup lang="ts">
import { useRouter } from 'vue-router';
import RoundedButton from '@/components/ui/RoundedButton.vue';
import { useGroupStore } from '@/stores/group';
import { leaveSettings } from './leave-settings';

defineProps<{
  title: string;
}>();

const router = useRouter();
const groupStore = useGroupStore();
</script>

<template>
  <header class="settings-header">
    <RoundedButton
      :aria-label="$t('common.back')"
      class="settings-header__back"
      icon="arrow-left"
      size="large"
      type="secondary"
      @click="leaveSettings(router, groupStore.group?.group_id)"
    />
    <h1 class="settings-header__title">{{ title }}</h1>
  </header>
</template>

<style lang="scss">
.settings-header {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  padding: $spacing-3 $spacing-5 $spacing-2;
  position: relative;

  // The secondary tint blends into the page background: the mockups paint the
  // button white on the settings screens.
  &__back {
    background-color: $color-white;
    border: 1px solid $color-border-medium;
  }

  &__title {
    color: $color-neutral-highest;
    font: $text-bold-large;
    left: 50%;
    letter-spacing: $text-bold-large-spacing;
    margin: 0;
    // Centered on the page, not on the space left over by the back button.
    max-width: 60%;
    overflow: hidden;
    position: absolute;
    text-overflow: ellipsis;
    transform: translateX(-50%);
    white-space: nowrap;
  }
}
</style>
